<template>
	<div class="trun-role">
		<div class="page-handle">
			<div class="left">
				<a-button v-auth="'100301'" type="primary" @click="ckDeptModel">添加子组织</a-button>
				<a-button v-auth="'100302'" type="primary" @click="sortClick">{{isSort?'保存':'排序'}}</a-button>
			</div>
			<div class="right">
				<a-input-search placeholder="请输入组织名称" style="width: 200px"/>
			</div>
		</div>
		<div class="page-content page-turn-content">
			<h-table
					:isDropRow="isSort"
					:columns="columns"
					:dataSource="data"
					:rowKey="record => record.deptId"
					@drop="drop"
					class="hospital-table"
					size="middle"
			>
				<template slot="codeRange" slot-scope="row">
					<template v-if="row.record.codeRange">{{row.record.codeRange}}</template>
					<template v-else>-</template>
				</template>
				<template slot="hospitalCode" slot-scope="row">
					<template v-if="row.record.hospitalCode">{{row.record.hospitalCode}}</template>
					<template v-else>-</template>
				</template>
				<template slot="optUser" slot-scope="row">
					<a v-auth="'100303'" href="javascript:;" @click="editDeptInfo(row)" class="cf-mr10">编辑</a>
					<template v-if="row.record.deptId !==2 && row.record.deptId!==3">
						<a v-auth="'100304'" v-if="row.record.enable == 1" href="javascript:;"
						   @click="editDeptStatus(row)"
						   class="cf-mr10">禁用</a>
						<a v-auth="'100304'" v-else href="javascript:;" @click="editDeptStatus(row)"
						   class="cf-mr10">启用</a>
					</template>
					<a-icon v-if="isSort" type="drag"/>
				</template>
			</h-table>
		</div>
		<page-model @close="closeModel" :visible="visible">
			<dept-add
					v-if="visible"
					@close="closeModel"
					:deptRow="deptRow"
					:deptType="deptType"
					:deptId="parentId"
			></dept-add>
		</page-model>
		<page-model @close="closeModel" :visible="statusIsVisible">
			<div class="form-model-main reset-model">
				<div class="add-page-content dept-page-content">
					<template v-if="enable == 1">
						<div class="title">禁用操作</div>
						<div class="content">确定要禁用吗？</div>
					</template>
					<template v-else>
						<div class="title">启用操作</div>
						<div class="content">确定要启用吗？</div>
					</template>
					<div class="confrim-footer">
						<a-button type="primary" class="cf-mr10" :loading="isHttpSubmit" @click="submitUpStatus">确定
						</a-button>
						<a-button @click="cancelSubmit">取消</a-button>
					</div>
				</div>
			</div>
		</page-model>
	</div>
</template>

<script>
  import DeptAdd from "./deptAdd.vue";
  import HTable from "../../components/common/h-table/HTable";

  const columns = [
    {
      title: "序号",
      dataIndex: "orderNum",
    },
    {
      title: "组织名称",
      dataIndex: "deptName"
    },
    {
      title: "协作组条码设置",
      dataIndex: "codeRange",
      scopedSlots: {customRender: "codeRange"}
    },
    {
      title: "代号",
      dataIndex: "hospitalCode",
      scopedSlots: {customRender: "hospitalCode"}
    },
    {
      title: "操作",
      scopedSlots: {customRender: "optUser"}
    }
  ];
  export default {
    data() {
      return {
        columns,
        data: [],
        page: 1,
        pageSize: 10,
        isSort: false,
        deptType: 0,
        parentId: "1",
        visible: false,
        statusIsVisible: false,
        isHttpSubmit: false,
        handleText: "排序",
        upDeptId: '',
        enable: 1,
        deptRow: {}
      };
    },
    components: {DeptAdd, HTable},
    watch: {
      $route(val) {
        let queryDeptId = val.query.deptType ? val.query.deptType.split("-") : [];
        this.parentId = val.query.parentId ? val.query.parentId : "1";
        this.isSort = false;
        if (queryDeptId.length > 0) {
          this.deptType = queryDeptId[queryDeptId.length - 1];
        } else {
          this.deptType = 0;
        }
        this.page = 1;
        this.getDeptData();
      }
    },
    mounted() {
      let queryDeptId = this.$route.query.deptType
        ? this.$route.query.deptType.split("-")
        : [];
      this.parentId = this.$route.query.parentId
        ? this.$route.query.parentId
        : "1";
      if (queryDeptId.length > 0) {
        this.deptType = queryDeptId[queryDeptId.length - 1];
      }
      this.getDeptData();
    },
    methods: {
      editDeptInfo(row) {
        this.visible = true;
        this.deptRow = row.record;
      },
      editDeptStatus(row) {
        this.statusIsVisible = true;
        this.upDeptId = row.record.deptId;
        this.enable = row.record.enable;
      },
      ckDeptModel() {
        this.deptRow = {};
        this.visible = true;
      },
      sortClick() {
        this.isSort = !this.isSort;
        if (!this.isSort) {
          this.sortByAjax();
        }
      },
      closeModel() {
        this.visible = false;
        this.statusIsVisible = false;
        this.deptRow = {};
        this.getDeptData();
        this.$parent.getDeptTreeList();
      },
      cancelSubmit() {
        this.statusIsVisible = false;
      },
      submitUpStatus() {
        this.isHttpSubmit = true;
        this.$get("dept/updateDeptStatus/" + this.upDeptId).then(
          res => {
            if (this.enable == 1) {
              this.$message.success("用户禁用成功！");
            } else {
              this.$message.success("用户启用成功！");
            }
            this.isHttpSubmit = false;
            this.closeModel()
          },
          error => {
            this.isHttpSubmit = false;
            if (this.enable == 1) {
              this.$message.error("用户禁用失败！");
            } else {
              this.$message.error("用户启用失败！");
            }
          }
        );
      },
      drop(startItem, endTtem) {
        let startIndex = startItem.orderNum;
        let endIndex = endTtem.orderNum;
        this.data.map(item => {
          if (item.deptId === endTtem.deptId) {
            item.orderNum = startIndex;
          }
          if (item.deptId === startItem.deptId) {
            item.orderNum = endIndex;
          }
        });
        this.argSort();
      },
      sortByAjax() {
        const formData = [];
        this.data.forEach(item => {
          formData.push({
            id: item.deptId,
            pid: item.parentId
          });
        });
        this.$post("dept/orderDept", formData, true).then(res => {
          this.getDeptData();
        });
      },
      argSort() {
        let result = [];
        this.data
          .sort((a, b) => {
            return a.orderNum - b.orderNum;
          })
          .map(item => {
            result.push(item);
          });
        this.data = result;
      },
      getDeptData() {
        let params = {};
        if (this.deptType) {
          params = {
            deptType: this.deptType,
            parentId: this.parentId,
            queryAll: true
          };
        } else {
          params = {
            queryAll: true
          };
        }
        this.$get("dept/findDeptTreeList", params).then(res => {
          if (this.deptType) {
            this.data = res.data.data[0].children;
            let _index = 1;
            this.data.forEach(item => {
              item.orderNum = _index;
              _index = _index + 1;
            });
          } else {
            this.data = res.data.data;
            let _index = 1;
            this.data.forEach(item => {
              item.orderNum = _index;
              _index = _index + 1;
            });
          }
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
	.form-model-main {
		.dept-page-content {
			width: 380px;
		}
		.dept-page-content .content {
			border: 0;
			padding: 0 0 30px 0;
			font-size: 18px;
		}
	}

	.trun-role {
		/deep/ .page-turn-content {
			.fx-table .td:first-child {
				width: 10% !important;
			}
			.fx-table .td:nth-child(2) {
				width: 40% !important;
			}
			.fx-table .td:nth-child(3) {
				width: 20% !important;
			}
			.fx-table .td:nth-child(4) {
				width: 15% !important;
			}
			.fx-table .td:last-child {
				width: 15% !important;
			}
			.div-tbody {
				width: 100%;
			}
		}
		.fx-table.hospital-table {
			border: 1px solid #f0f2f5;
		}
		/deep/ .fx-table ul li.table-tbody:last-child {
			.td {
				border-bottom: 0;
			}
		}
	}
</style>
